import React, {useEffect, useState} from 'react';
import styles from './ReportsFiltersUI.module.scss';
import {Autocomplete, Button, Chip, TextField} from "@mui/material";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {FIRST_REPORT_DATE} from "../../../common/constants/constService";
import {DATE_TYPES, startEndDateInitial} from "../../../common/utils";
import {useSelector} from "react-redux";
import moment from "moment/moment";
import {dateFormatWithHours} from "../../../utils/common";

const offersHasBrands = [123, 132, 157, 99];
const offersHasInfluencers = [123, 132, 157];

let reportTypes = [];

// Rapor ekranlarında en sık istenen aralıklar. Tarih seçiciler kontrollü olduğu için
// bunlara basmak iki alanı da doldurur.
const DATE_PRESETS = [
    {key: "today", label: "Bugün", range: () => [dayjs(), dayjs()]},
    {key: "yesterday", label: "Dün", range: () => [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")]},
    {key: "d7", label: "Son 7 gün", range: () => [dayjs().subtract(6, "day"), dayjs()]},
    {key: "d30", label: "Son 30 gün", range: () => [dayjs().subtract(29, "day"), dayjs()]},
    {key: "mtd", label: "Bu ay", range: () => [dayjs().startOf("month"), dayjs()]},
    {
        key: "prev", label: "Geçen ay",
        range: () => [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")]
    }
];

const longDate = new Intl.DateTimeFormat("tr-TR", {day: "numeric", month: "long", year: "numeric"});

const ReportsFiltersUI = ({
                              onGenerateButtonClicked,
                              hideReportTypeDropdown = true,
                              hideOfferSelectionDropdown = true
                          }) => {
    const offersList = useSelector((state) => state.offersList.offers);
    const userData = useSelector((state) => state.auth.user);
    const [dropdownReportTypes, setDropdownReportTypes] = useState(reportTypes);
    const [startEndDateValue, setStartEndDateValue] = React.useState(startEndDateInitial);
    const [selectedOfferId, setSelectedOfferId] = useState("");
    const [selectedReportTypeId, setSelectedReportTypeId] = useState(0);


    const [offers, setOffers] = useState([]);

    useEffect(() => {
        reportTypes = [
            {
                id: 0,
                value: "Ürün Performansı"
            }
        ]
        if (!!offersList && offersList.length > 0) {


            if (userData.isMasterPassword) {
                reportTypes = [
                    {
                        id: 0,
                        value: "Ürün Performansı"
                    },
                    {
                        id: 1,
                        value: "Influencer Performansı"
                    },
                    {
                        id: 2,
                        value: "Marka Performansı"
                    }
                ]
                setOffers(offersList);
            } else {
                const selectedOffers = userData.user.offer_id_list;
                let offerObjects = [];

                if (selectedOffers) {
                    if (selectedOffers.includes(",")) {
                        const offerList = selectedOffers.split(",");
                        offerList.forEach(id => {
                            const offer = offersList.find(offer => offer.offerId === Number(id));
                            if (!!offer) offerObjects.push(offer);
                        })
                    } else {
                        const offer = offersList.find(offer => offer.offerId === Number(selectedOffers));
                        offerObjects.push(offer);
                    }
                    setOffers(offerObjects);

                    const selectedOfferIds = offerObjects.map(offer => offer.offerId);

                    selectedOfferIds.forEach(offerId => {
                        const isOfferIdExistOnOfferHasBrands = offersHasBrands.find(offer => offer === offerId);
                        if (!!isOfferIdExistOnOfferHasBrands) {
                            reportTypes.push(
                                {
                                    id: 2,
                                    value: "Marka Performansı"
                                }
                            )
                        }
                        const isOfferIdExistOnOfferHasInfluencers = offersHasInfluencers.find(offer => offer === offerId);
                        if (!!isOfferIdExistOnOfferHasInfluencers) {
                            reportTypes.push(
                                {
                                    id: 1,
                                    value: "Influencer Performansı"
                                }
                            )
                        }
                    })
                }

            }
        }
        // birden fazla teklifi olan kullanıcıda aynı rapor türü tekrar tekrar eklenebiliyordu
        setDropdownReportTypes(reportTypes.filter((type, i, all) => all.findIndex(t => t.id === type.id) === i));
    }, [offersList]);// eslint-disable-line react-hooks/exhaustive-deps

    const isButtonDisabled = () => (!startEndDateValue.endDate ||
        !startEndDateValue.startDate ||
        (hideOfferSelectionDropdown ? false : !selectedOfferId));
    const getOfferValue = () => {
        const selected = selectedOfferId ? offers.find(offer => offer.offerId === selectedOfferId) : null;
        return (!!selected) ? selected.id + ' - ' + selected.name : "";

    };

    const handleReportTypeDropdownChange = (e) => {
        const {textContent} = e.target;
        if (!textContent) return;
        setSelectedReportTypeId(Number(dropdownReportTypes.find(reportType => reportType.value === textContent).id))
    };

    const handleStartDateChange = (newValue, type) => {
        if (!newValue) return;
        if (type === DATE_TYPES.START_DATE) {
            setStartEndDateValue(prevState => ({
                ...prevState,
                startDate: newValue
            }));
        } else {
            setStartEndDateValue(prevState => ({
                ...prevState,
                endDate: newValue
            }));
        }
    };

    const applyPreset = (preset) => {
        const [startDate, endDate] = preset.range();
        setStartEndDateValue({startDate, endDate});
    };

    const isPresetActive = (preset) => {
        const {startDate, endDate} = startEndDateValue;
        if (!startDate || !endDate) return false;
        const [presetStart, presetEnd] = preset.range();
        return startDate.isSame(presetStart, "day") && endDate.isSame(presetEnd, "day");
    };

    const getRangeSummary = () => {
        const {startDate, endDate} = startEndDateValue;
        if (!startDate || !endDate) return "Rapor için bir tarih aralığı seçin";
        const days = endDate.diff(startDate, "day") + 1;
        return longDate.format(startDate.$d) + " – " + longDate.format(endDate.$d) + "  ·  " + days + " gün";
    };

    const handleOfferDropdownChange = async (e) => {
        const {textContent} = e.target;
        if (!textContent) return;
        setSelectedOfferId(Number(textContent.split(" - ")[0]));
    }


    const handleGetReport = async () => {

        if (!startEndDateValue || !startEndDateValue.startDate || !startEndDateValue.endDate) return;
        const startDate = moment(startEndDateValue.startDate.$d)
            .set({hour: 0, minute: 0, second: 0}).format(dateFormatWithHours);
        const endDate = moment(startEndDateValue.endDate.$d)
            .set({hour: 23, minute: 59, second: 59}).format(dateFormatWithHours);
        const payload = {
            reportTypeId: selectedReportTypeId,
            offerId: selectedOfferId,
            startDate: startDate,
            endDate: endDate
        }
        onGenerateButtonClicked(payload);

    };


    return (
        <div className={styles.filterPanel}>
            <div className={styles.filterRow}>
                {!!offers && offers.length > 0 && !(hideReportTypeDropdown && hideOfferSelectionDropdown) &&
                    <div className={styles.fieldGroup}>
                        {!hideReportTypeDropdown && <Autocomplete
                            freeSolo
                            name="Report Types"
                            required
                            size="small"
                            value={dropdownReportTypes.find(reportType => reportType.id === selectedReportTypeId)?.value}
                            options={dropdownReportTypes.map(reportType => reportType.value)}
                            onChange={e => handleReportTypeDropdownChange(e)}
                            sx={{width: 210}}
                            renderInput={(params) => <TextField {...params} label="Rapor Türü"/>}
                        />}

                        {!hideOfferSelectionDropdown && <Autocomplete
                            name="Offers"
                            freeSolo
                            required
                            size="small"
                            value={getOfferValue()}
                            options={offers.map(offer => offer.offerId + " - " + offer.name)}
                            onChange={handleOfferDropdownChange}
                            sx={{width: 240}}
                            renderInput={(params) => <TextField {...params} label="Kampanya"/>}
                        />}
                    </div>}

                <div className={styles.fieldGroup}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker label="Başlangıç Tarihi"
                                    format="DD.MM.YYYY"
                                    minDate={dayjs(FIRST_REPORT_DATE)}
                                    disableFuture
                                    value={startEndDateValue.startDate}
                                    slotProps={{textField: {size: 'small', sx: {width: 170}}}}
                                    onChange={(newValue) =>
                                        handleStartDateChange(newValue, DATE_TYPES.START_DATE)}/>
                        <span className={styles.dateSeparator}>–</span>
                        <DatePicker label="Bitiş Tarihi"
                                    format="DD.MM.YYYY"
                                    disableFuture
                                    minDate={dayjs(startEndDateValue.startDate)}
                                    value={startEndDateValue.endDate}
                                    slotProps={{textField: {size: 'small', sx: {width: 170}}}}
                                    onChange={(newValue) =>
                                        handleStartDateChange(newValue, DATE_TYPES.END_DATE)}/>
                    </LocalizationProvider>
                </div>

                <Button
                    disabled={isButtonDisabled()}
                    variant="contained"
                    color="confirmButton"
                    sx={{
                        fontWeight: 700,
                        fontSize: 13,
                        height: 40,
                        px: 3,
                        marginLeft: 'auto',
                        whiteSpace: 'nowrap'
                    }}
                    onClick={handleGetReport}>Raporu Getir</Button>
            </div>

            <div className={styles.presetRow}>
                <span className={styles.presetLabel}>Hızlı seçim</span>
                {DATE_PRESETS.map(preset => (
                    <Chip key={preset.key}
                          label={preset.label}
                          size="small"
                          clickable
                          color={isPresetActive(preset) ? "primary" : "default"}
                          variant={isPresetActive(preset) ? "filled" : "outlined"}
                          onClick={() => applyPreset(preset)}/>
                ))}
                <span className={styles.rangeSummary}>{getRangeSummary()}</span>
            </div>
        </div>
    );
};

export default ReportsFiltersUI;
